import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import StickyCta from "@/components/StickyCta";
import JotformAgent from "@/components/JotformAgent";
import HomePage from "@/pages/HomePage";
import TrackPage from "@/pages/TrackPage";

// Auto-scroll to top on route change, but respect in-page #anchors
function ScrollManager() {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash, key]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/track/:slug" element={<TrackPage />} />
            <Route path="/digestive" element={<TrackPage slugProp="digestive-microbiome" />} />
            <Route path="/vitality" element={<TrackPage slugProp="hormonal-vitality" />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <StickyCta />
        <JotformAgent />
      </BrowserRouter>
    </div>
  );
}

export default App;
